import polyfill from './polyfills';

polyfill()
  .then(() => {
    return import(/* webpackChunkName: "mv" */ '@google/model-viewer');
  });
